<a
    ui-m040-c040-promotion-banner
    class="!bg-accent"
    [hyundaiRouterLink]="dealer().highlightBanner?.slug"
    [trackingElTarget]="dealer().highlightBanner?.slug"
    [trackingElLabel]="dealer().highlightBanner?.trackingLabel"
    fragment="highlight"
    trackingElType="banner"
    tracking
    trackingEvent="element_click"
>
    <div class="flex flex-col lg:flex-row">
        @let highlightBannerHeadline = dealer().highlightBanner?.highlightBannerHeadline ?? '' | footnotes;
        <span class="font-text" [innerHTML]="highlightBannerHeadline()"></span>
        @if (dealer().highlightBanner?.highlightBannerSubheadline) {
            @let highlightBannerSubheadline = dealer().highlightBanner?.highlightBannerSubheadline ?? '' | footnotes;
            <span class="hidden lg:block">&nbsp;-&nbsp;</span>
            <span class="font-medium" [innerHTML]="highlightBannerSubheadline()"></span>
        }
    </div>
</a>
